import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';

const UserManager = ({ token }) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    setLoading(true);
    try {
      const res = await axios.get('https://sijapan.sman10fajarharapan.sch.id/api/users', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setUsers(res.data);
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  const handleChangeRole = async (id, newRole) => {
    try {
      await axios.put(`https://sijapan.sman10fajarharapan.sch.id/api/users/${id}/role`, { role: newRole }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      Swal.fire('Sukses', `Role berhasil diubah menjadi ${newRole}`, 'success');
      fetchUsers();
    } catch (err) {
      Swal.fire('Gagal', 'Terjadi kesalahan', 'error');
    }
  };

  // --- FUNGSI RESET PASSWORD DENGAN INPUT CUSTOM ---
  const handleResetPassword = async (id, username) => {
    const { value: newPassword } = await Swal.fire({
      title: `Reset Password: ${username}`,
      html: '<p style="font-size:13px; color:#64748b">Masukkan password baru untuk user ini:</p>',
      input: 'text', // Gunakan 'password' jika ingin karakter tersembunyi
      inputPlaceholder: 'Ketik password baru...',
      inputValue: '123456', // Nilai default
      showCancelButton: true,
      confirmButtonText: 'Simpan Password',
      confirmButtonColor: '#f59e0b',
      cancelButtonText: 'Batal',
      inputValidator: (value) => {
        if (!value) {
          return 'Password tidak boleh kosong!';
        }
        if (value.length < 6) {
          return 'Password minimal 6 karakter!';
        }
      }
    });

    if (newPassword) {
      try {
        await axios.put(`https://sijapan.sman10fajarharapan.sch.id/api/users/${id}/reset`, 
          { newPassword: newPassword }, // Kirim password baru ke backend
          { headers: { Authorization: `Bearer ${token}` } }
        );
        
        Swal.fire({
            title: 'Berhasil!',
            html: `Password untuk <b>${username}</b> telah diubah menjadi:<br/><h3 style="color:#4361ee; margin-top:10px">${newPassword}</h3>`,
            icon: 'success'
        });
      } catch (err) {
        Swal.fire('Gagal', 'Terjadi kesalahan sistem.', 'error');
      }
    }
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: 'Hapus User?',
      text: "User ini tidak akan bisa login lagi.",
      icon: 'error',
      showCancelButton: true,
      confirmButtonText: 'Hapus Permanen',
      confirmButtonColor: '#d33'
    });

    if (result.isConfirmed) {
      try {
        await axios.delete(`https://sijapan.sman10fajarharapan.sch.id/api/users/${id}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        fetchUsers();
        Swal.fire('Terhapus', 'User berhasil dihapus', 'success');
      } catch (err) {
        Swal.fire('Gagal', 'Error server', 'error');
      }
    }
  };

  return (
    <div style={{ paddingBottom: '50px' }}>
      <h2 style={{ color: '#1e293b', marginBottom: '20px' }}>👥 Manajemen User & Hak Akses</h2>
      
      <div style={{ background: 'white', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)', overflow: 'hidden', border: '1px solid #e2e8f0' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: '#f8f9fa' }}>
              <th style={{ padding: '15px', textAlign: 'left' }}>Username / NIP</th>
              <th style={{ padding: '15px', textAlign: 'left' }}>Nama Lengkap</th>
              <th style={{ padding: '15px', textAlign: 'left' }}>Role (Hak Akses)</th>
              <th style={{ padding: '15px', textAlign: 'center' }}>Aksi</th>
            </tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.id} style={{ borderBottom: '1px solid #f1f5f9' }}>
                <td style={{ padding: '15px', fontWeight: 'bold', color: '#64748b' }}>{u.username}</td>
                <td style={{ padding: '15px' }}>{u.nama_lengkap}</td>
                <td style={{ padding: '15px' }}>
                  <select 
                    value={u.role} 
                    onChange={(e) => handleChangeRole(u.id, e.target.value)}
                    style={{ 
                        padding: '6px 10px', borderRadius: '6px', border: '1px solid #cbd5e1', 
                        background: u.role === 'admin' ? '#dbeafe' : 
                                    u.role === 'piket' ? '#fef3c7' : 
                                    u.role === 'wakasek' ? '#e0e7ff' : 
                                    u.role === 'kepsek' ? '#f3e8ff' : 'white',
                        fontWeight: 'bold', color: '#334155'
                    }}
                  >
                    <option value="guru">Guru Biasa</option>
                    <option value="piket">Guru Piket</option>
                    <option value="wakasek">Wakil Kepala Sekolah</option>
                    <option value="kepsek">Kepala Sekolah</option>
                    <option value="admin">Administrator</option>
                  </select>
                </td>
                <td style={{ padding: '15px', textAlign: 'center' }}>
                  <button 
                    onClick={() => handleResetPassword(u.id, u.username)}
                    style={{ marginRight: '8px', padding: '6px 12px', background: '#f59e0b', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize:'12px', fontWeight:'bold' }}
                    title="Ubah Password"
                  >
                    🔑 Reset
                  </button>
                  <button 
                    onClick={() => handleDelete(u.id)}
                    style={{ padding: '6px 12px', background: '#ef4444', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize:'12px', fontWeight:'bold' }}
                  >
                    🗑️ Hapus
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UserManager;